export enum AuthActions {
  SIGN_OUT = "auth/signOutAndClearStore",
}
